module.exports = __webpack_public_path__ + "img/33266-098.55fda0dd.jpg";